import { useSearchParams } from 'react-router-dom'

export function NoDisponiblePage() {
  const [searchParams] = useSearchParams()
  const mensaje = searchParams.get('mensaje') || 'Esta campaña ya no se encuentra disponible.'

  return (
    <div className="min-h-screen bg-[#eff6ff] flex items-center justify-center py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <img
            src="/logo-tonal-negro.png"
            alt="Tonal"
            className="mx-auto h-12 w-auto"
            onError={(e) => { e.currentTarget.style.display = 'none' }}
          />
        </div>

        {/* Icon */}
        <div className="mb-8">
          <div className="mx-auto w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 14.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>

        {/* Message */}
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Campaña No Disponible
          </h1>
          <p className="text-gray-600 mb-6">{mensaje}</p>

          {/* Contact Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <svg className="w-5 h-5 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="font-medium text-blue-900 mb-1">¿Necesitas ayuda?</h3>
                <p className="text-sm text-blue-800 mb-2">
                  Si tienes alguna pregunta, contáctanos:
                </p>
                <div className="text-sm text-blue-800">
                  <p><strong>Email:</strong> a.villota@tonalstrategies.com</p>
                  <p><strong>Teléfono:</strong> +593 98 194 1812</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500">
            Powered by <strong>Tonal Strategies</strong>
          </p>
        </div>
      </div>
    </div>
  )
}
